export const defaultEoi = {
    // contact details
    ua_companyname: null,
    ua_title: null,
    ua_othertitle: null,
    ua_firstname: null,
    ua_lastname: null,
    ua_preferredcontacttelephoneno: null,
    ua_emailaddress: null,
    ua_directornameformfa: null,
    ua_directoremailformfa: null,
    // business location
    ua_tradingaddressline1: null,
    ua_tradingaddressline2: null,
    ua_tradingaddresstowncity: null,
    ua_tradingaddresscounty: null,
    ua_tradingaddresspostcode: null,
    ua_tradingpostcodefromryi: null,
    ua_registeredaddresssameastrading: 2,
    ua_registeredaddressline1: null,
    ua_registeredaddressline2: null,
    ua_registeredaddresstowncity: null,
    ua_registeredaddresscounty: null,
    ua_registeredaddresspostcode: null,
    ua_registeredpostcodefromryi: null,
    // business details
    ua_website: null,
	ua_typeofbusinessownership: null,
	ua_businessownershipother: null,
	ua_companyregistrationnumber: null,
	ua_datestartedtrading: null,
	ua_utrnumber: null,
	ua_dateregisteredwithhmrc: null,
    ua_haveregisteredcharitystatus: null,
	ua_charitynumber: null,
	ua_dateregisteredwithcharitycommission: null,
    ua_registeredonmutualsregister: null,
    ua_mutualsregisterregistrationnumber: null,
	ua_areyouvatregistered: 2,
	ua_vatregistrationnumber: null,
    ua_sectorparentlookup: null,
	ua_sectornamefromryi: null,
    ua_umisector: null,
	ua_annualturnover: null,
	ua_financialyearend: null,
	ua_howmuchsalesdirecttopublic: null,
	ua_numberofemployees: null,
	ua_partofgroup: false,
	ua_groupname: null,
     ua_companygroupaddress: null,
	ua_companygrouppostcode: null,
	ua_companygrouprefno: null,
	ua_groupemployees: null,
	ua_groupturnover: null,
    ua_whatdoesthebusinessdo: null,
    // declarations
     ua_agreetodataprotection: null,
	ua_wheredidyouhearaboutus: null,
	ua_wheredidyouhearaboutusother: null,
	ua_pleasedescribeproject: null,
    // general
    ua_iccontractid: process.env.VUE_APP_CONTRACT_ID_EOI,
    ua_eoitype: 1,
    ua_icexpressionofinterestid: null,
    ua_sharepointfoldername: null,
    ua_submiteoi: 2,
    ua_currentstatus: null,
    ua_contact: null,
    ua_currentpageinapplication: null,
    ua_readyforfunding: null
};

export const defaultApplication = {
    // Business Details
    ua_businessname: null,
    ua_sectorparentlookup: null,
    ua_sectorlookup: null,
    ua_legalstatus: null,
    ua_companyregistrationnumber: null,
    ua_datebusinessstartedtrading: null,
    ua_registeredaddress: null,
    ua_registeredaddressline2: null,
    ua_registeredaddresstowncity: null,
    ua_registeredaddresspostcode: null,
    ua_registeredpostcode: null,
    ua_tradingaddresssameasregistered: 2,
    ua_tradingaddress: null,
    ua_tradingaddressline2: null,
    ua_tradingaddresstowncity: null,
    ua_tradingaddresspostcode: null,
    ua_tradingpostcode: null,
    ua_uniquetaxreferencenumber: null,
    ua_dateregisteredwithhmrc: null,
    ua_legalstatusother: null,
    ua_businessoverview: null,
    ua_briefdescriptionoforganisation: null,
    ua_lastapprovedemployees: null,
    ua_isthebusinesspartofagroup: 2,
    ua_parentcompanydetails: null,
    ua_haveregisteredcharitystatus: null,
    ua_registeredonmutualsregister: null,
    ua_mutualsregisterregistrationnumber: null,
    // Contact Details
    ua_maincontactname: null,
    ua_maincontactposition: null,
    ua_maincontacttelephone: null,
    ua_maincontactmobile: null,
    ua_maincontactemail: null,
    // Directors
    ua_directornameforofferletter: null,
    ua_directoremailforofferletter: null,
    // Project Details 1
    ua_describeproposal: null,
    ua_descriptionofproject: null,
    ua_consultancydays: null,
    // Project Details 2
    activities: [],
    ua_totalamountrequesting: null,
    // Business Finances
    ua_financialyearenddate: null,
    ua_howintendtofinancetheproject: null,
    ua_lastapprovedturnover: null,
    ua_briefdescription: null,
    // Market Information
    ua_doyouknowwhoyourmaincompetitorsare: 1,
    competitors: [],
    // Project Impacts
    jobs: [],
    ua_willsafeguardjobs: 0,
    ua_jobssafeguarded: null,
    ua_forecastnumberofjobs: 0,
    // Payment Details
    ua_bankaccountname: null,
    ua_businessbanksortcode: null,
    ua_businessbankaccountnumber: null,
    // Declarations
    ua_decexperianverification: 2,
    ua_decexperianrecordkept: 2,
    ua_decpersonalcreditcard: 2,
    ua_decincorrectorincomplete: 2,
    ua_decnotstartedproject: 2,
    ua_decnoactivityuntilofferaccepted: 2,
    ua_decoffermaybepublicised: 2,
    ua_decinfostoredelectronically: 2,
    ua_decawardatdiscretionofumi: 2,
    ua_decnopartnerdisqualified: 2,
    ua_decnodirectorbankrupt: 2,
    ua_decnodirectorrequestedtorepay: 2,
    ua_decnodirectorlast5yearscivilaction: 2,
    ua_decsuppliersnotconnected: 2,
    ua_decpreowneditemsnoterdf: 2,
    ua_umioptin: 2,
    // general
    ua_iccontractid: '',
    ua_icexpressionofinterest: null,
    ua_icapplicationid: null,
    ua_submitapplication: false,
    ua_currentstatus: 'Application Created',
    ua_contact: null,
    ua_currentpageinapplication: null,
    // additional information
    ua_doccapitalgrantsupplementaryquestions: 2,
    ua_financialappendicesspreadsheetuploaded: 2,
    ua_doclastyearfinancial: 2,
    ua_doclatestmanagementaccounts: 2,
    ua_docgroupaccounts: 2,
    ua_docmonthlyprofitlossforecast: 2,
    ua_doccashflowforecasts: 2,
    ua_docdirectorcvs: 2
};

export const defaultClaim = {
    ua_othercommentsforclaimassessment: null,
    ua_declareinvoicesuploaded: 0,
    ua_declarebankstatementsuploaded: 0,
    ua_declarechequeevidenceuploaded: 0,
    ua_declareBACSreportuploaded: 0,
    ua_declarePayPalstatementuploaded: 0,
    ua_declareCreditCardstatementuploaded: 0,
    ua_declareactivityexpenditurefullydefrayed: 0,
    ua_declareinfotrueandcomplete: 0,
    ua_declareprojectcomplete: 0,
    ua_isthisthefinalclaim: 1,
    ua_sharepointclaimfoldername: null,
};

export const STATUS_MAP = {
    eoi: {
        created: 0,
        'eoi-created': 0,
        'eoi-submitted': 1,
        'customer-app-submitted': 1,
        'budi-grant-referral': 1,
        'customer-app-assessment-started': 2,
        'customer-app-in-assessment': 2,
        'eoi-in-assessment': 2,
        'customer-app-in-query': 3,
        'eoi-in-query': 3,
        ineligible: 4,
        'customer-app-rejected': 4,
        'customer-app-withdrawn': 5,
        'eoi-withdrawn': 5,
        withdrawn: 5,
        'customer-app-eligible': 6,
        eligible: 6
    },
    application: {
        created: 0,
        'application-created': 0,
        'application-submitted': 1,
        'customer-app-submitted': 1,
        'offer-letter-signed': 1,
        'stage-2-assessment-started': 2,
        'assessment-complete': 2,
        'application-assigned': 2,
        'in-query-cust': 3,
        'in-query-customer': 3,
        'in-query-umi': 3,
        'app-in-query': 3,
        'application-rejected': 4,
        'application-withdrawn': 5
    },
    claim: {
        created: 0,
        'customer-ready-to-claim': 0,
        'claim-created': 0,
        'claim-started': 1,
        'claim-submitted': 1,
        awaiting: 2,
        'claim-authorised': 2,
        'tvb-claim-assessment-1-started': 2,
        'final-claim-assessment-ddcd-pass': 2,
        'final-claim-assessment-ddcd-push-back-to-customer': 3,
        'final-claim-assessment-ddcd-started': 2,
        'initial-claim-assessment-ddcd-started': 2,
        'initial-claim-assessment-started': 2,
        'claim-pushed-back': 3,
        'final-claim-assessment-ddcd-query': 3,
        'initial-claim-assessment-ddcd-in-query-cust': 3,
        'initial-claim-assessment-ddcd-query': 3,
        'tvb-claim-assessment-1-push-back-to-customer': 3,
        'tvb-claim-assessment-1-in-query-cust': 3,
        'tvb-claim-assessment-1-in-query-umi': 3,
        'in-query-cust': 3,
        'in-query-customer': 3,
        'tvb-claim-assessment-2-in-query-umi': 3,
        'activity-not-being-claimed': 4,
        'claim-rejected': 4,
        'tvb-claim-assessment-1-fail': 5,
        'claim-paid': 6
    }
};
